import axios from "./axios.interceptors";
import { SalesApiResponse, SalesParams } from "app/types/service-types/SalesTypes";

function toDDMMYYYY(iso: string) {
  if (!iso) return iso;
  if (iso.includes("/")) return iso;
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export const SalesService = {
  async getSales(params: SalesParams): Promise<SalesApiResponse> {
    const { page, size, ...rest } = params;
    const query = {
      ...rest,
      fromDate: toDDMMYYYY(rest.fromDate),
      toDate: toDDMMYYYY(rest.toDate),
      page: params.page ?? 0,
      size: params.size ?? 20,
    };
    delete query.sort;
    const { data } = await axios.get<SalesApiResponse>("/api/sales", { params: query });
    return data;
  },


  async exportPdf(params: SalesParams) {
    const { page, size, sort, ...rest } = params;
    const query = {
      ...rest,
      fromDate: toDDMMYYYY(rest.fromDate),
      toDate: toDDMMYYYY(rest.toDate),
    };
   return axios.get("/api/sales/pdf", {
    params: query,
    responseType: "arraybuffer",
  });

  },

  async exportXls(params: SalesParams) {
    const { page, size, sort, ...rest } = params;
    const query = {
      ...rest,
      fromDate: toDDMMYYYY(rest.fromDate),
      toDate: toDDMMYYYY(rest.toDate),
    };
    return axios.get("/api/sales/xls", {
      params: query,
      responseType: "blob",
    });
  },
};
